//intlReducer
export const UPDATE_INTL = 'UPDATE_INTL'

